import PropTypes from "prop-types";
import useCountdown from "./useCountdown";

/**
 * The seconds left as a number and a shrinking bar. It ticks itself, so
 * only this re-renders ten times a second, not the page around it.
 * `questionKey` restarts it for a new question.
 */
function Countdown({ secondsLeft, total, questionKey, big = false }) {
  const left = useCountdown(secondsLeft, questionKey);
  if (left === null) return null;
  const shown = Math.ceil(left);
  const fraction = total > 0 ? Math.min(1, left / total) : 0;
  return (
    <div className="flex items-center gap-3">
      {/* Announced once per question, not every tick. */}
      <span className="sr-only">{total} seconds to answer.</span>
      <span
        className={`w-14 shrink-0 text-right font-display font-semibold tabular-nums ${
          big ? "text-5xl" : "text-3xl"
        } ${shown <= 5 ? "text-destructive" : ""}`}
        data-testid="countdown-seconds"
        aria-hidden="true"
      >
        {shown}
      </span>
      <div className="h-3 flex-1 overflow-hidden rounded-full bg-muted" aria-hidden="true">
        <div
          className={`h-full rounded-full transition-[width] duration-100 ease-linear ${
            shown <= 5 ? "bg-destructive" : "bg-primary"
          }`}
          style={{ width: `${fraction * 100}%` }}
        />
      </div>
    </div>
  );
}

Countdown.propTypes = {
  secondsLeft: PropTypes.number,
  total: PropTypes.number.isRequired,
  questionKey: PropTypes.number,
  big: PropTypes.bool,
};

export default Countdown;
